import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { push, replace } from 'react-router-redux';

const mapActionCreators = {
  push,
  replace,
};

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

class Mobile extends Component {

  state = {
    tabIndex: 0
  }


  componentWillMount() {
  }

  componentDidMount() {
  }

  componentWillReceiveProps(newProps) {
  }

  componentWillUnmount() {
  }

  render = () => {
    const { onDismiss } = this.props;
    return <div className='submit_tips_container'>
      <div className='submit_tips_content_m'>
        <div className='submit_tips_title_m'>{`Submitted Project \nSecurity Detection`}</div>
        <div className='holder'>
          <div className='flex_row' style={{marginTop:'.45rem'}}>
            <img alt='' className='submit_tips_icon_m' src={require('../assets/1.png')}></img>
            <div>
              <div className='submit_tips_text1_m'>Free Security Detection</div>
              <div className='submit_tips_text2_m'>{`All projects submitted for detecting will go throughat least 18 security detect items in 3 categories！`}</div>
            </div>
          </div>
          <div className='flex_row' style={{ marginTop: '.45rem' }}>
            <img alt='' className='submit_tips_icon_m' src={require('../assets/2.png')}></img>
            <div>
              <div className='submit_tips_text1_m'>Least 18 security detection items</div>
              <div className='submit_tips_text2_m'>{`Transcation Security
Token  Security
Team Info  Security`}</div>
            </div>
          </div>
          <div className='flex_row' style={{ marginTop: '.45rem' }}>
            <img alt='' className='submit_tips_icon_m' src={require('../assets/3.png')}></img>
            <div>
              <div className='submit_tips_text1_m'>All results are disclosed to the user</div>
              <div className='submit_tips_text2_m'>{`Just, fair and open`}</div>
            </div>
          </div>
        </div>
        <div className='submit_tips_confirm' onClick={onDismiss}>OK</div>
        <div className='submit_tips_close' onClick={onDismiss}></div>
      </div>
    </div>
  }
}

export default connect(mapStateToProps, mapActionCreators)(injectIntl(Mobile));
